import EventEmitter from "@widget/core/EventEmitter";
export default new EventEmitter();
